import { render, staticRenderFns } from "./ApplicantNew.vue?vue&type=template&id=dd5ea850"
import script from "./ApplicantNew.vue?vue&type=script&lang=js"
export * from "./ApplicantNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports